<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header btn-holder tab-nav-holder">
      <div class="col-sm-12 nav-tab-holder">
        <ul class="nav nav-tabs" role="tablist">
          <li>
            <a
              (click)="tab = tabs.ChannelAdjustments"
              [class.active]="tab === tabs.ChannelAdjustments"
              matTooltip="Account level channel adjustments will apply to all rentals if no rental specific channel adjustments are available."
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              Channel Adjustments
            </a>
          </li>
          <li>
            <a
              *ngIf="showGroupRates"
              (click)="tab = tabs.GroupRates"
              [class.active]="tab === tabs.GroupRates"
              matTooltip="Group rates are rates which apply to multiple rentals at once."
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              Group Rates
            </a>

            <a
              *ngIf="!showGroupRates"
              (click)="$event.preventDefault()"
              class="tone-down"
              matTooltip="You need more than one rental to apply group rates."
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              Group Rates
            </a>
          </li>
          <ng-container *ngIf="showDiscounts">
            <li>
              <a
                (click)="tab = tabs.LosDiscounts"
                [class.active]="tab === tabs.LosDiscounts"
                matTooltip=""
                matTooltipPosition="below"
                matTooltipClass="text-center"
              >
                LOS Discounts
              </a>
            </li>
            <li>
              <a
                (click)="tab = tabs.DiscountCodes"
                [class.active]="tab === tabs.DiscountCodes"
                matTooltip=""
                matTooltipPosition="below"
                matTooltipClass="text-center"
              >
                Discount Codes
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="fas fa-times"></span>
      </a>
    </div>

    <div class="modal-body">
      <div class="tab-content">
        <app-channel-adjustments-table *ngIf="tab === tabs.ChannelAdjustments"> </app-channel-adjustments-table>

        <app-rates-table *ngIf="showGroupRates && tab === tabs.GroupRates"> </app-rates-table>

        <app-los-discount-table *ngIf="tab === tabs.LosDiscounts"> </app-los-discount-table>

        <app-discount-codes-table *ngIf="tab === tabs.DiscountCodes"> </app-discount-codes-table>
      </div>
    </div>
  </div>
</div>
